import * as React from 'react';
import { observable, computed, action } from 'mobx';
import { observer } from 'mobx-react';

export interface IViewMore {
    currentHtml: string;
    isExpanded: boolean;
    showViewMore: boolean;
    toggleExpanded: () => void;
    setTextDiv: (div: HTMLDivElement | null) => IViewMore;
}

interface ChildProps {
    viewMore: IViewMore;
}

interface Props {
    dangerouslySetInnerHTML: string;
    component: React.ComponentType<ChildProps>;
}

@observer
export class ViewMore extends React.Component<Props> implements IViewMore {
    @observable private fullHtml: string;
    @observable private shortHtml: string;
    @observable isExpanded = false;
    @observable showViewMore = false;
    @computed get currentHtml() {
        return this.isExpanded ? this.fullHtml : this.shortHtml;
    }
    private textDiv: HTMLDivElement | null = null;

    constructor(props: Props) {
        super(props);
        this.fullHtml = this.props.dangerouslySetInnerHTML;
        this.shortHtml = this.fullHtml;
    }

    @action
    componentWillUpdate(nextProps: Props) {
        if (this.fullHtml !== nextProps.dangerouslySetInnerHTML) {
            this.fullHtml = nextProps.dangerouslySetInnerHTML;
            this.shortHtml = this.fullHtml;
            this.isExpanded = false;
            this.showViewMore = false;
            if (this.textDiv) {
                setTimeout(() => this.calculateShortHtml());
            }
        }
    }

    setTextDiv = (div: HTMLDivElement | null) => {
        this.textDiv = div;
        this.calculateShortHtml();
        return this;
    };

    private calculateShortHtml() {
        const div = this.textDiv;
        if (!div) {
            return;
        }

        while (div.clientHeight < div.scrollHeight - 1) {
            // 1px allowance for Edge
            const index = div.innerHTML.lastIndexOf(' ');
            if (index >= 0) {
                div.innerHTML = `${div.innerHTML.substr(0, index)}…`;
            } else {
                break;
            }
        }
        this.shortHtml = div.innerHTML;
        this.showViewMore = this.shortHtml !== this.fullHtml;
    }

    toggleExpanded = () => {
        this.isExpanded = !this.isExpanded;
    };

    render() {
        const Component = this.props.component;
        return <Component viewMore={this} />;
    }
}
